export default {
  'Edit': 'Edit',
  'Save': 'Save',
  'Cancel': 'Cancel',
  'Ok': 'Ok',
  'and': 'and',
  'Yes': 'Yes',
  'No': 'No',
  'Or': 'Or',
  'Confirm': 'Confirm',
  'Saved success': 'Saved Successfully',
  'Warning': 'Warning',
  'Cancel success': 'Canceled Successfully',
  'Account binding failure': 'Account Linking Failed',
  'UPDF Code verify': 'Login with UPDF verfication code',
  'UPDF Login': 'UPDF account login',
  'UPDF Password login': 'Login with UPDF password',
  'UPDF Forgot password': 'UPDF forgot password',
  'UPDF Reset password': 'UPDF reset password',
  'UPDF Set account info': 'UPDF set account info',
  'UPDF Callback {loginType}': 'UPDF Callback {loginType}',
  'UPDF Wechat login': 'UPDF Wechat login',
  'Welcome to': 'Welcome to',
  'Wechat': 'Wechat',
  'Click reload': 'Click to reload',
  'Log in by scanning QR code on Wechat<br>and following our official account': 'Log in by scanning the WeChat QR code <br>and follow our official account.',
  'Email': 'Email',
  'Phone': 'Phone number',
  'Unregistered account will be registered after entering the verification code': 'Unregistered phone number or email will be registered after entering the verification code',
  'Unregistered email will be registered after entering the verification code': 'Unregistered email will be registered after entering the verification code.',
  'Or continue with:': 'Or continue with:',
  'By clicking continue, you accept our': 'By clicking continue, you accept our',
  'License Agreement': 'License Agreement',
  'Privacy Policy': 'Privacy Policy',
  'Enter your phone number or email...': 'Enter your phone number or email...',
  'Enter your email address...': 'Enter your email address...',
  'Please enter a valid phone number or email': 'Please enter a valid phone number or email',
  'Please enter a valid email address': 'Please enter a valid email address',
  'Please enter your password': 'Please enter your password',
  'Enter new password': 'Enter new password',
  'The new password must be at least {min} characters.': 'The new password must be at least {min} characters.',
  'The new password must be within {max} characters.': 'The new password must be within {max} characters.',
  'Nickname must be within {max} characters.': 'Nickname must be within {max} characters.',
  'Enter your password again': 'Enter your new password again',
  'Please enter your password again': 'Please enter your new password again',
  'Those passwords didn\'t match. Try again.': 'Those passwords didn\'t match. Try again.',
  'Reset success,please log in use new password': 'Password reset successful. Please log in with your new password.',
  'Continue': 'Continue',
  'Check mobile': 'Verify your phone number',
  'Check email': 'Verify your email address',
  'Please enter the code sent to<br><span>{account}</span>': 'Please enter the code sent to<br><span>{account}</span>. The code is valid for 10 minutes.',
  'If you do not receive the email, please check your spam or junk folder.': 'If you do not receive the email, please check your spam or junk folder.',
  'Resend': 'Resend',
  'seconds remaining to resend code': 'seconds left to resend code',
  'Verify Later': 'Verify Later',
  'Log in with password': 'Log in with password',
  'Log in with password-2': 'Log in with password',
  'Log in with code': 'Log in with verification code',
  'OR': 'OR',
  'Back': 'Back',
  'Forgot password?': 'Forgot password?',
  'Log in': 'Log in',
  'Set password': 'Set password',
  'Reset your password': 'Reset your password',
  'Add a photo': 'Add a photo',
  'Your name': 'Your name',
  'What should we call you?': 'What should we call you?',
  'First name': 'First Name',
  'Last name': 'Last Name',
  'Please enter first name': 'Please enter first name',
  'Please enter last name': 'Please enter last name',
  'Please enter your nickname': 'Please enter your nickname',
  'Set a password': 'Set a password',
  'Please enter new password': 'Please enter a new password',
  'Set success': 'Set successfully',
  'Log in success': 'Log in successfully',
  'Click "<span>Open UPDF</span>" in the above dialog box above to log into your account.': 'Click "<span>Open UPDF</span>" in the dialog box above to log into your account.',
  'Can\'t see the dialog box? Click here.': 'Can\'t see the dialog box? Click here.',
  'Account center': 'Account Center',
  'Account Center': 'Account Center',
  'Account': 'Manage your account',
  'Personal info': 'Personal info',
  'Photo': 'Avatar',
  'Preferred name': 'Display name',
  'Email-2': 'Email',
  'UID': 'UID',
  'Mobile phone': 'Phone number',
  'Country': 'Country',
  'Linked Accounts Manage': 'Manage Linked Accounts',
  'Select country': 'Select country',
  'Your Plans of UPDF': 'Your UPDF Plans',
  'Upgrade to UPDF Pro to get full access to all features without limits.': 'Upgrade to UPDF Pro to get full access to all features without limits.',
  'Subscriptions': 'Products and Plans',
  'You can manage you plan in Apple ID settings': 'You can manage you plans in Apple ID settings',
  'Free': 'Free',
  'Annual': 'Annual',
  'Monthly': 'Monthly',
  'Quarterly': 'Quarterly',
  'Perpetual': 'Perpetual',
  'Giveaway': 'Giveaway',
  'Cancel subscription': 'Cancel subscription',
  'Current Plan': 'Current Plan',
  'Renews': 'Renew',
  'Expire on': 'Expire on',
  'VIP Duration': 'VIP Duration',
  'Month': 'Month',
  'Months': 'Months',
  'Activate': 'Activate',
  'Use Across Devices': 'Use across devices',
  'As you already have a subscription plan, activating the "Giveaway" plan would make both plans run on your account, but it will not increase the original subscription time. Are you sure you want to activate the "Giveaway" plan?': 'Since you already have a subscription plan, activating the "Giveaway" plan will allow both plans to function on your account; however, it will not extend the duration of your original subscription. Are you sure you want to activate the "Giveaway" plan?',
  'Activate the "Giveaway" plan': 'Activate the "Giveaway" plan',
  'Password management': 'Manage Password',
  'You can set password if you don\'t prefer logging in with codes.': 'You can set password if you prefer not to log in with verification code.',
  'Change Password': 'Change Password',
  'Set Password': 'Set Password',
  'Are you sure log out your account?': 'Are you sure log out of your account?',
  'Log out of UPDF account': 'Log out of UPDF account',
  'You may not be able to use all features after logging out of your account until you log back in.': 'After logging out, you will not be able to use all features without limits.',
  'Log Out': 'Log Out',
  'Confirm input error': 'The confirmation code is incorrect',
  'Permanently delete your personal information and all data, this operation can\'t be recovered. Enter <span style="color: var(--el-color-primary)">{uid}</span> to confirm the operation.': 'Permanent deletion of your personal information and data cannot be recovered. Enter <span style="color: var(--el-color-primary)">{uid}</span> to confirm the operation.',
  'Delete your account': 'Delete Your Account',
  'Your personal information and all data will be removed permanently and can\'t be recovered.': 'Your personal information and all data will be removed permanently and can\'t be recovered.',
  'Delete': 'Delete',
  'The avatar must be an image.': 'The avatar must be an image.',
  'You will miss the following membership rights when the subscription expired.': 'You will miss the following membership rights when the subscription expired.',
  'Expire on {date}': 'Expire on {date}',
  'Redeem': 'Redeem',
  'Redeem-2': 'Redeem',
  'The license will be bound to your account, and extend the expiration date.': 'The duration of the redeemed membership or plans will be added to your account.',
  'Please input license.': 'Please input redemption code',
  'Incorrect license code.': 'Invalid redemption code.',
  'Redeem success.': 'Redeemed Successfully',
  'Use across Windows, macOS, Android, iOS++No watermark++All annotate tools++Edit PDF text, images and links++Convert PDF to Word, Excel, PPT++OCR Text Recognition++Extract, insert, replace, split pages++Free updates and upgrades': 'Use across Windows, macOS, Android, iOS++No trial watermark++All annotate tools++Edit PDF text, images and links++Convert PDF to Word, Excel, PPT++OCR Text Recognition++Reorder, rotate, extract, insert, split pages++Free updates and upgrades',
  'Keep UPDF Pro': 'Keep UPDF Pro',
  'Continue Cancellation': 'Continue Unsubscribing',
  'Renew': 'Renew',
  'Activate Subscription': 'Activate Subscription',
  'Success! Your UPDF PRO subscription will be renewed on {date}': 'Your subscription is recovered! Your UPDF Pro subscription will be renewed on {date}',
  'Upgrade to Pro': 'Upgrade to Pro',
  'Please enter the new mobile phone number': 'Please enter a new mobile phone number',
  'Please enter a valid mobile phone number': 'Please enter a valid mobile phone number',
  'Please enter a new email address': 'Please enter a new email address',
  'Please enter a valid email address-2': 'Please enter a valid email address',
  'Verification code error': 'Verification code error',
  'Set': 'Set',
  'Change': 'Change',
  'Link': 'Link',
  'Unlink': 'Unlink',
  'not set': 'Not set',
  'not set-2': 'Not linked',
  'Phone Number': 'Phone number',
  'Google': 'Google',
  'Apple ID': 'Apple ID',
  'Set Phone Number': 'Set Phone number',
  'Please enter the phone number and verification code.': 'Please enter the phone number and verification code.',
  'Set Email': 'Set email',
  'Please enter the email and verification code.': 'Please enter the email and verification code.',
  'Please enter the phone number': 'Please enter the phone number',
  'Please enter your email': 'Please enter your email',
  'Verification code': 'Verification code',
  'Send code': 'Send verification code',
  'Resend-2': 'Resend',
  'please enter the verification code': 'please enter the verification code',
  'Please use wechat to scan the QR code and follow the official account binding': 'Please scan the Wechat QR code and follow the official account to link your account',
  'To keep your account safe': 'To keep your account safe',
  'Please enter the verification code sent to': 'Please enter the verification code sent to',
  'Linked Accounts': 'Linked accounts',
  'Binding success': 'Linked successfully',
  'linked': 'linked',
  'Unbind successfully': 'Unlinked successfully',
  'Unbinding failure': 'Unlinking failed',
  'Are you sure you want to untie them': 'Are you sure you want to unlink them?',
  'UCloud Expires On': 'UPDF Cloud Expires On',
  'UPDF Plan': 'UPDF Pro',
  'Full access to all UPDF features and UCloud benefits.': 'Full access to all UPDF features and UPDF Cloud benefits.',
  'Full access to all UPDF features and comes with 1-year UCloud benefits.': 'Full access to all UPDF features and comes with 1-year UPDF Cloud benefits.',
  'Upgrade to UPDF Pro to get all UPDF features and UCloud benefits.': 'Upgrade to UPDF Pro to get all UPDF features and UPDF Cloud benefits.',
  'Full access to all UPDF features.': 'Full access to all UPDF features.',
  'Create a Company': 'Create a company',
  'Please fill in the company information': 'Please fill in the company information.',
  'Company Name': 'Company name',
  'Industry Type': 'Industry type',
  'Number of Employees': 'Number of employees',
  'Set up enterprise account': 'Set up enterprise account',
  'Confirm your enterprise account. You will become the administrator with full management rights.': 'Confirm your enterprise account. You will become the administrator with full administrative permissions.',
  'Email Address': 'Email address',
  'Email Address or Phone Number': 'Email address or phone number',
  'Please enter the password of {companyName}': 'Please enter the password of {companyName}',
  'Your company is created successfully.': 'Your company is created successfully.',
  'Invite members to join the company by email or by copying the link.': 'Invite members to join the company by email or by copying and sharing the link.',
  'Invite members': 'Invite members',
  'Invite Later': 'Invite later',
  'Send Invitation': 'Send invitation',
  'Copy Link': 'Copy link',
  'UPDF PRO': 'UPDF Pro',
  'Your account now has full access to all features without limits.': 'Your account now has full access to all features without limits.',
  'Your account has not been authorized by the administrator': 'Your account has not been authorized by the administrator.',
  'All': 'All',
  'Authorized': 'Authorized',
  'Unauthorized': 'Unauthorized',
  'Company Logo': 'Company logo',
  'Contact Information': 'Contact information',
  'Administrator': 'Administrator',
  'Email-1': 'Email',
  'Phone Number-1': 'Phone number',
  'Transfer': 'Transfer',
  'Permanently delete your company information and all data, this operation can not be recovered. Enter <span style="color: var(--el-color-primary)">{companyId}</span> to confirm the operation.': 'Permanent deletion of your personal information and data cannot be recovered. Enter <span style="color: var(--el-color-primary)">{companyId}</span> to confirm the operation.',
  'Assigned': 'Assigned',
  'Quick Entry': 'Quick Entry',
  'Last Login Time': 'Last Login Time',
  'Operation': 'Operation',
  'Search': 'Search',
  'Link copied': 'Link copied',
  'Email, separated by enter': 'Email, separated by enter',
  'This email is already on the list': 'This email is already on the list',
  'Invalid Invite Code': 'Invalid Invite Code',
  'You have joined the company.': 'You have joined the company.',
  'The following accounts are bound to the current login method. Please select the account to log in.': 'The following accounts are linked to the current login method. Please select the account to log in.',
  'Enter password': 'Enter password',
  'Please enter the password of <span>{username}</span>': 'Please enter the password of <span>{username}</span>',
  'This account is already logged in': 'This account is already logged in',
  'You have successfully joined {companyName}': 'You have successfully joined {companyName}',
  'Download UPDF now to share membership benefits': 'Download UPDF now to share membership benefits',
  'Download UPDF': 'Download UPDF',
  'Please Enter..': 'Please Enter..',
  'Full Name': 'Full Name',
  'Please login first': 'Please login first',
  'administrator': 'Administrator',
  'Dissolve Company': 'Dissolve Company',
  'Permanently delete your business information and data. This action is non-recoverable. Enter <span style="color: var(--el-color-primary)">{companyId}</span> to confirm.': 'Permanent deletion of your company information and data cannot be recovered. Enter <span style="color: var(--el-color-primary)">{companyId}</span> to confirm deletion.',
  'Accommodation and Food Services': 'Accommodation and Food Services',
  'Administration, Business Support, and Waste Management Services': 'Administration, Business Support, and Waste Management Services',
  'Agriculture, Forestry, Fishing, and Hunting': 'Agriculture, Forestry, Fishing, and Hunting',
  'Arts, Entertainment, and Recreation': 'Arts, Entertainment, and Recreation',
  'Construction': 'Construction',
  'Educational Services': 'Educational Services',
  'Finance and Insurance': 'Finance and Insurance',
  'Healthcare and Social Assistance': 'Healthcare and Social Assistance',
  'Information and Communication': 'Information and Communication',
  'Manufacturing': 'Manufacturing',
  'Mining': 'Mining',
  'Other Services': 'Other Services',
  'Professional, Scientific, and Technical Services': 'Professional, Scientific, and Technical Services',
  'Real Estate, Rental, and Leasing': 'Real Estate, Rental, and Leasing',
  'Wholesale and Retail Trade': 'Wholesale and Retail Trade',
  'Transportation and Warehousing': 'Transportation and Warehousing',
  'Utilities': 'Utilities',
  'Order No.': 'Order No.',
  'Amount': 'Amount',
  'Product': 'Product',
  'Payment Time': 'Payment Time',
  'Payment Status': 'Payment Status',
  'Your order is being processed. It may take from 2 to 6 working days to process your payment using the payment method of Sofort/Pix/Boleto. You will be informed via email once the process is done.': 'Your order is being processed. It may take between 2 to 6 working days to process your payment using one of following payment method of Sofort/Pix/Boleto. You will be informed via email once the process is done.',
  'Unpaid': 'Unpaid',
  'Failure': 'Failure',
  'Paid': 'Paid',
  'Refunded': 'Refunded',
  'Pending': 'Pending',
  'Expire on:': 'Expire on:',
  'Card Expired': 'Card Expired',
  'The payment card can only be changed for orders under subscription. For canceled orders, the renewal has been cancelled, and the payment card cannot be changed. If you need to change the payment card, please renew the subscription of this order in "Subscriptions" first.': 'The payment card can only be changed for valid subscription orders. For canceled orders, the renewal has been canceled, and the payment card cannot be changed. If you need to change the payment card, please renew the subscription for this order in \'Subscriptions\' first.',
  'Canceled': 'Canceled',
  'Change Card': 'Change Card',
  'Active': 'Active',
  'Inactive': 'Inactive',
  'Credit cards associated with subscription orders can be managed here. Here you can modify the credit card that will be used for future renewals. To cancel or restore a subscription, please operate in "Subscriptions".': 'Credit cards associated with subscription orders can be managed here. Here you can modify the credit card that will be used for future renewals. To cancel or restore a subscription, please operate in "Subscriptions".',
  'Security': 'Security',
  'Payment Management': 'Payment Management',
  'Order Information': 'Order Information',
  'Pay Again': 'Pay Again',
  'Change successfully': 'Change successfully',
  'Change failed, please try again': 'Change failed, please try again',
  'Order information only includes orders purchased through the website. Applepay and Google Play orders will not be displayed.': 'Order information only includes orders purchased through the website. Apple Pay and Google Play orders will not be displayed.',
  'Membership': 'Membership',
  '(Educational)': '(Educational)',
  'Issue an invoice': 'Issue an invoice',
  'Download invoice': 'Download Invoice',
  'Bill To:': 'Bill To:',
  'Name': 'Name',
  'Address': 'Address',
  'ZIP Code': 'ZIP Code',
  'Submit': 'Submit',
  'Please check the information carefully. It cannot be modified after submission. Are you sure to submit?': 'Please check the information carefully. It cannot be modified after submission. Are you sure to submit?',
  'Are you sure?': 'Are you sure?',
  'Invoice Information': 'Invoice Information',
  'Must enter 1-20 characters': 'Must enter 1-20 characters',
  'Must enter 1-100 characters': 'Must enter 1-100 characters',
  'Must enter 1-500 characters': 'Must enter 1-500 characters',
  'Must enter 1-200 characters': 'Must enter 1-200 characters',
  'Must enter 1-50 characters': 'Must enter 1-50 characters',
  'Device Management': 'Device Management',
  'Desktop': 'Desktop',
  'Last active': 'Last Active',
  'Login out': 'Log out',
  'Mobile': 'Mobile',
  'After being removed, the device will automatically log out and needs to be logged in again. Do you confirm the operation?': 'After being removed, the device will automatically log out and needs to be logged in again. Do you confirm the operation?',
  'Settings': 'Settings',
  'Avatar': 'Avatar',
  'Sign Out': 'Sign Out',
  'Join Time': 'Join Time',
  'Remove Member': 'Remove Member',
  'Deauthorize': 'Deauthorize',
  'Authorize': 'Authorize',
  'Authorization': 'Authorization',
  'Company Overview': 'Company Overview',
  'Redeem-3': 'Redeem',
  'Buy Licenses': 'Buy Licenses',
  'Member Management': 'Member Management',
  'Deleted Successfully': 'Deleted successfully',
  'Deauthorized Successfully': 'Deauthorized successfully',
  'Authorized Successfully': 'Authorized successfully',
  'Redeemed successfully': 'Redeemed successfully',
  'Company Settings': 'Company Settings',
  'Company Infomation': 'Company Infomation',
  'The invitation has been sent successfully': 'The invitation has been sent successfully',
  'Incorrect format of email': 'Incorrect format of email',
  'Incorrect format of phone number': 'Incorrect format of phone number',
  'Dissolved successfully': 'Dissolved successfully',
  'License View': 'Enterprise License Dashboard',
  'Member View': 'Member View',
  'Total Licenses': 'Total Licenses',
  'Total Members': 'Total Members',
  'Reset': 'Reset',
  'Number of Members': 'Number of Members',
  'Company ID': 'Company ID',
  'No staff selected': 'No Member selected',
  'Please enter the email': 'Please enter the email',
  'Add Member': 'Add Member',
  'Please enter the company name': 'Please enter the company name',
  'Permanently delete your business information and data. This action is non-recoverable.': 'Permanent deletion of your company information and data cannot be recovered.',
  'Skip': 'Skip',
  'You are not an administrator and do not have permission to access this page.': 'You are not an administrator and do not have permission to access this page.',
  'Enterprise management': 'Enterprise management',
  'Flexible configuration, tracking, and management of licenses within your company.': 'Flexible configuration, tracking, and management of licenses within your company.',
  'Enterprise management dashboard': 'Enterprise management dashboard',
  'Authorization failed': 'Authorized failed',
  'Buy Now': 'Buy Now',
  'Buy': 'Buy',
  'Insufficient licenses available! Want to buy more licenses?': 'Licenses are insufficient! Want to buy more licenses?',
  'Privilege grant failed': 'Authorized failed',
  'Number of Users': 'Number of Users',
  'Member Avatar': 'Member Avatar',
  'Password must be 6-20 characters, and should have numbers, English letters, or symbols.': 'Password must be 6-20 characters, and should have numbers, English letters, or symbols.',
  'Not set': 'Not set',
  'The current account is the administrator of {companyName}, please log in to the enterprise management platform and dissolve the company to complete the deletion.': 'The current account is the administrator of {companyName}. To delete the account, please log in to the Enterprise Management Dashboard and dissolve the company.',
  'Permanently and irreversibly delete the member\'s account and all data. Click OK to complete the deletion': 'Permanent deletion of the member\'s account and data can not be recovered. Click OK to confirm deletion.',
  'Got it': 'Got it',
  'CompanyId Error': 'Company ID Error',
  'Select': 'Select',
  'Enterprise management background': 'Enterprise Management Dashboard',
  'Authorized employees': 'Authorized employees',
  'Authorized members': 'Authorized members',
  'The current account already has a perpetual plan. If you need to redeem it again, please change to another account.': 'The current account already has a perpetual plan. If you need to use the redemption code, please change to another account.',
  'Number of redemption licences': 'Number of redemption codes',
  'Invalid redemption code': 'Invalid redemption code',
  'Allocation of Licence Quotas (Number of employees with licences/Total number of licences)': 'Allocation of License Quotas (Number of employees with licenses/Total number of licenses)',
  'Authorization of Employee Status (Number of employees with licences/Total number of employees)': 'Authorization of Employee Status (Number of employees with licences/Total number of employees)',
  'All the selected enterprise users will be permanently deleted. Do you want to continue?': 'All the selected enterprise users will be permanently deleted. Are you sure to continue?',
  'Share Invitation': 'Share Invitation',
  'Add Manually': 'Add Manually',
  'Batch Import': 'Batch Import',
  'Export All Member': 'Export All Members',
  'Export Selected Member': 'Export Selected Members',
  'Account: required. 6-60 characters. The account can not be repeated. It supports numbers, English letters and English symbols.': 'Account: This field is required. It must be 6 to 60 characters long, cannot be duplicated, and supports numbers, English letters, and English symbols.',
  'Name: required. The length is limited to 60 characters.': 'Name: This field is required and has a limit of 60 characters.',
  'Password: optional. 6-20 characters. It supports numbers, English letters and English symbols.': 'Password: This field is optional. 6 to 20 characters long and can include numbers, English letters, and English symbols.',
  'Mobile phone number: optional. Phone number format.': 'Mobile phone number:This field is optional. Phone number format.',
  'Whether to authorize: optional. Please fill in [Yes], [No]. If not filled, the default is [No].': 'Authorize or not: :This field is optional. Please fill in [Yes], [No]. If not filled, the default is [No].',
  'Uploaded Failed': 'Uploaded failed',
  'The content is wrong. Please modify and reupload.': 'The content is wrong. Please modify and reupload.',
  'Uploaded Succeed!': 'Uploaded successfully',
  'Employee Table Template.xlsx': 'Employee Table Template.xlsx',
  'You can click to download the Employee table template and fill out the table': 'You can click to download the Employee table template and fill it out.',
  'Copy the following information and notify the user to log in.': 'Copy the following information and notify the user to log in.',
  'Must be letters, digits or symbols': 'Must be letters, digits or symbols',
  'Please contact administrator to reset password': 'Please contact administrator to reset password',
  'Please enter account/email/phone number': 'Please enter account/email/phone number',
  'Please enter an effective account/email/phone number': 'Please enter an effective account/email/phone number',
  'Please enter account/email': 'Please enter account/email',
  'Please enter an effective account/email': 'Please enter an effective account/email',
  'Drag the template here, or <em>click to upload</em>': 'Drag the template here, or <em>click to upload</em>',
  'Account_1': 'Account',
  'Inactivated': 'Inactivated',
  'Activated': 'Activated',
  'Deleted': 'Deleted',
  'Register & log in UPDF account You can convert <span>2 files for FREE</span>': 'By registering and logging in UPDF account, you can convert <span>2 files per day for free</span>',
  'Register & log in UPDF account You can convert <span>2 files per day</span>for FREE': 'By registering and logging in UPDF account, you can convert<span>2 files per day</span>for free',
  '{{.shareName}} added you to {{.companyName}}': '{{.shareName}} added you to {{.companyName}}',
  '{{.shareName}} added you to {{.companyName}}. You can share UPDF membership benefits now. The account information is as follows. Remember to save it and log in.': '{{.shareName}} added you to {{.companyName}}. You now have full access to all UPDF features. Please find your account information beow. Remember to save it and use it to log in.',
  'Password': 'Password',
  'Full name': 'Full name',
  'Your password has been reset': 'Your password has been reset',
  'Your password has been reset by the administrator. The account information is as follows. Remember to save it and log in.': 'Your password has been reset by the administrator. Please find your account information beow. Remember to save it and use it to log in.',
  'Upload the filled out template:': 'Upload the filled out template:',
  'Please enter account': 'Please enter account',
  'Please enter password': 'Please enter password',
  'Must enter 6-20 characters': 'Must enter 6-20 characters',
  'Please enter 1-30 characters': 'Please enter 1-30 characters',
  'Must enter 1-30 characters': 'Must enter 1-30 characters',
  'Please enter email': 'Please enter email',
  'Please enter an effective email': 'Please enter a valid email',
  'Please enter phone number': 'Please enter phone number',
  'Copy': 'Copy',
  'Only one file can be uploaded': 'Only one file can be uploaded',
  'Accounts can not be repeated. Only numbers, letters, and symbols are supported; it is recommended to name accounts with numbers or letters plus a company suffix (for example: abc@updf, 0100@updf) to ensure uniqueness.': 'Account names can not be duplicated. Only digits, letters, and symbols are supported. It is recommended to name accounts with numbers or letters plus a company suffix (for example: abc@updf, 0100@updf) to ensure uniqueness.',
  'Reason of failure:': 'Reasons for import failure',
  'Information copied': 'Information copied',
  'Message sent': 'Message sent',
  'The file can not exceed 10MB': 'The file can not exceed 10MB',
  'Must enter 6-60 characters': 'Must enter 6-60 characters',
  'The file exceeds the limit of 30,000 lines, please modify and upload again': 'The file exceeds the limit of 30,000 lines, please modify and upload again',
  'Support format': 'Support format',
  'Send a message to notify the user to log in': 'Send a message to notify the user to log in',
  'Please enter email/phone number': 'Please enter email/phone number',
  'Please enter an effective email/phone number': 'Please enter a valid email/phone number',
  'Added successfully': 'Added successfully',
  'Member Info': 'Member Info',
  'Send': 'Send',
  'The company name only supports Chinese characters': 'The company name only supports Chinese characters',
  'http_error_4023': 'The redemption code is for Enterprise. Please go to Enterprise Management Dashboard to redeem it.',
  'E-mail: optional. Email format.': 'E-mail: optional. Email format. It cannot be duplicated.',
  'Phone number: optional. Phone number format.': 'Phone number: optional. Phone number format. It cannot be duplicated.',
  'Enterprise name': 'Enterprise Name',
  'Redeem Now': 'Redeem Now',
  'Auto-redemption': 'Auto-redemption',
  'You have purchased the Enterprise Plan. Do you want to auto-redeem your plan?': 'You have purchased the Enterprise Plan. Do you want to auto-redeem your plan?',
  'Later': 'Later',
  'Redemption code': 'Redemption code',
  'Users': 'Users',
  'It is an enterprise license code, please go to Enterprise Management Dashboard to redeem it.': 'The redemption code is for Enterprise. Please go to Enterprise Management Dashboard to redeem it.',
  'Open UPDF': 'Open UPDF',
  'Personal Account': 'Individual Account',
  'Enterprise Account': 'Enterprise Account',
  'Language Settings': 'Language Settings',
  'Language': 'Language',
  'Click "Open UPDF" to automatically log in to the enterprise account.': 'Click "Open UPDF" to automatically log in to the enterprise account.',
  'Click "Enterprise Management Dashboard", you can enter the Management Dashboard to redeem plan, set enterprise information, invite members to join the enterprise, and conduct enterprise management.': 'By clicking "Enterprise Management Dashboard", you can redeem plan, set enterprise information, invite members to join the enterprise, and manage your licenses.',
  'Company': 'Company',
  'Please enter your purchased UPDF redemption code, the successful redemption will increase the number of authorized licenses for the company.': 'Please enter your UPDF enterprise redemption code, the successful redemption will increase the number of authorized licenses for the company.',
  'Click to Accept': 'Click to Accept',
  'Dissolve success': 'Dissolved successfully',
  'Upload files up to 100 per month': 'Upload up to 100 files per month',
  'Up to 1000 pages per file': 'Up to 1000 pages per file',
  'Ask questions up to 1000 times per month': 'Ask up to 1000 questions per month',
  'Up to 2GB per file': 'Up to 2GB per file',
  '10GB of FREE ADDITIONAL STORAGE': '10GB of cloud storage',
  'You have unlocked advanced AI features': 'You have unlocked advanced AI features',
  'UPDF AI Pro Plan': 'AI Assistant',
  'Upgrade': 'Upgrade',
  'Upgrade to UPDF AI Pro monthly Plan to unlock more AI features': 'Upgrade to AI Assistant Plan to unlock more AI features',
  'Full access to all UPDF AI features and UPDF Cloud benefits': 'Full access to all AI Assistant and UPDF Cloud features.',
  'Success! Your UPDF AI PRO subscription will be renewed on {date}': 'Recovered successfully! Your AI Assistant subscription will be renewed on {date}',
  'Keep UPDF AI Pro': 'Keep AI Assistant',
  'Continue with Apple': 'Continue with Apple',
  'Continue with Google': 'Continue with Google',
  'You can also <span>continue with SSO</span>': 'You can also <span>continue with SSO</span>',
  'Operation successful': 'Operation successful',
  'Operation failed, please try again': 'Operation failed, please try again',
  'Super Admin information': 'Super Admin information',
  'Transfer super Admin': 'Transfer super Admin',
  'Confirm to transfer super Admin?': 'Confirm to transfer super administrator?',
  'You will automatically log out of the management backend interface after the transfer': 'You will automatically log out of the Enterprise Management Dashboard after the transfer.',
  'Organization management': 'Organization management',
  'Super Admin can add 5 ordinary Admin; ordinary Admin have all the operation rights of the management backend, except the following functions: transfer super Admin; add and remove ordinary Admins; dissolve the company.': 'Super Admin can add 5 ordinary Admin; ordinary Admin have all the operation rights of the management backend, except the following functions: transfer super Admin; add and remove ordinary Admins; dissolve the company.',
  'Add Admin': 'Add Admin',
  'Admin list': 'Admin list',
  'Please enter the employee\'s account': 'Please enter the employee\'s account',
  'Confirm to remove Admin?': 'Confirm to remove Admin?',
  'After removal, the employee will not be able to enter the management backend': 'After removal, the employee will not be able to enter the management backend',
  'Duplicate addition': 'Duplicate addition',
  'Super admin cannot be added as a normal admin': 'Super admin cannot be added as a normal admin',
  'The super admin removes you from the admin of {{.companyName}}. You can continue to use the enterprise account, but you no longer have the authority to manage the enterprise. If you have any questions, please communicate with the super admin in time.': 'The super admin removes you from the admin of {{.companyName}}. You can continue to use the enterprise account, but you no longer have the authority to manage the enterprise. If you have any questions, please communicate with the super admin in time.',
  'The super admin adds you as a admin of {{.companyName}}. You can log in to the enterprise management backend to manage the enterprise. The admin\'s account password is your UPDF enterprise account password.': 'The super admin adds you as a admin of {{.companyName}}. You can log in to the enterprise management backend to manage the enterprise. The admin\'s account password is your UPDF enterprise account password.',
  '{{.shareName}} transfers the super administrator of {{.companyName}} to you. You can log in to the enterprise management backend to manage the enterprise. The administrator\'s account password is your UPDF enterprise account password.': '{{.shareName}} transfers the super administrator of {{.companyName}} to you. You can log in to the enterprise management backend to manage the enterprise. The administrator\'s account password is your UPDF enterprise account password.',
  'Enterprise management dashboard:': 'Enterprise management dashboard:',
  'Notification of transferring enterprise super admin': 'Notification of transferring enterprise super admin',
  'Notification of adding enterprise admin': 'Notification of adding enterprise admin',
  'Notification of removing enterprise admin': 'Notification of removing enterprise admin',
  'Administrators cannot be deleted': 'Administrators cannot be deleted',
  'A maximum of 5 normal administrators can be added': 'A maximum of 5 normal administrators can be added',
  'UPDF AI Unlimited': 'AI Assistant',
  'UPDF AI Standard': 'AI Assistant(Standard)',
  'UPDF AI Plan': 'AI Assistant',
  'Upload files unlimited per month++Up to 1000 pages per file++Ask questions unlimited times per month++Up to 2GB per file++100GB of FREE ADDITIONAL STORAGE': 'Upload files unlimited per month++Up to 1000 pages per file++Ask questions unlimited times per month++Up to 2GB per file++100GB of FREE ADDITIONAL STORAGE',
  'Success! Your {aiType} subscription will be renewed on {date}': 'Success! Your {aiType} subscription will be renewed on {date}',
  'Keep UPDF AI Unlimited': 'Keep AI Assistant',
  'Keep UPDF AI Standard': 'Keep AI Assistant(Standard)',
  'Organizational License View': 'Enterprise License Dashboard',
  'Unlimited': 'Unlimited',
  'Your company membership benefits will expire in {organizeExpiredTime} days and all membership benefits will be unavailable. Please contact UPDF sales promptly to renew your membership.': 'Your Enterprise Plan will expire in {organizeExpiredTime} days and all membership benefits will be unavailable. Please contact UPDF sales team to renew your membership.',
  'Your company\'s membership rights have expired and all membership rights are no longer available. Please contact UPDF sales today to renew your membership.': 'Your Enterprise Plan has expired and all membership rights are no longer available. Please contact UPDF sales team today to renew your membership.',
  'Function Settings': 'Function Settings',
  'Enterprise cloud management': 'Enterprise cloud management',
  'Enterprise AI management': 'Enterprise AI management',
  'Turn off': 'Turn off',
  'Trun on': 'Turn on',
  'When the function is turned on, employees can use the cloud function; when it is turned off, the cloud function is turned off and employee accounts can only use local files and cannot upload them to the cloud. This feature is enabled by default.': 'When turned on, employees can use the cloud function; when turned off, the the employees can only use local files and cannot upload them to the cloud. This feature is turned on by default.',
  'After closing, all Cloud functions under the employee account will be closed, and all files uploaded to the Cloud will be inaccessible. Are you sure?': 'When the cloud feature is turned off, it becomes unavailable, and the uploaded files will be inaccessible. Are you sure to turn it off?',
  'After closing, all Cloud functions under the employee account will be closed, and all files uploaded to the Cloud will be inaccessible. Since the AI function requires the Cloud to be turned on before it can be used, if you turn off the Cloud, the AI switch will be turned off at the same time. Are you sure?': 'When the cloud feature is turned off, it becomes unavailable, and the uploaded files will be inaccessible. Since the AI requires the cloud feature to be turned on, disabling the cloud feature will also deactivate the AI. Are you sure to turn it off?',
  'Once enabled, all Cloud functions under the employee account will be enabled, and files can be uploaded to Cloud. Are you sure?': 'When turned on, employees can use the cloud feature and upload files to the cloud. Are you sure to turn it on?',
  'When the function is turned on, employees can use AI; when it is turned off, the AI function is turned off. This function is a paid function. If you want to use AI, please contact sales': 'When the AI Assistant feature is turned on, AI is available to use. When turned off, the AI is unavailable. If you do not buy any AI Assistant Plan yet, you need to buy on pricing page or contact sales.',
  'After closing, all AI functions under the employee account will be closed, and all generated AI conversation content will be inaccessible. Are you sure?': 'When turned off, the AI Assistant becomes unavailable to employees, and all generated AI conversation content will be inaccessible. Are you sure to turn it off?',
  'After it is enabled, all AI functions under the employee account will be enabled. Are you sure?': 'When turned on, the AI Assistant will be accessible for employees. Are you sure to turn it on?',
  'This function is a paid function. If you want to use AI membership, please contact sales.': 'The AI Assistant requires a subscription before use. If you haven\'t purchased an AI Assistant Plan yet, please visit the pricing page or contact our sales team for assistance.',
  'Using the AI ​​function requires uploading documents to the Cloud. Please turn on the Cloud function first before turning on the AI ​​switch.': 'Using the AI Assistant requires uploading documents to the Cloud. Please turn on the Cloud function before turning on the AI ​​Assistant.',
  'I know': 'Got it',
  'Company User': 'Number of Users',
  'Company UPDF Licenses': 'Enterprise Licenses for UPDF',
  'Company AI Licenses': 'Enterprise Licenses for AI Asssitant',
  'UPDF': 'UPDF',
  'Use Of State': 'License Status',
  'Residue': 'Remaining',
  'More Operations': 'More options',
  'Buy UPDF Licenses': 'Buy UPDF Pro',
  'Buy AI Licenses': 'Buy AI Assistant',
  'UPDF Authorize': 'Authorize UPDF Pro',
  'AI Authorize': 'Authorize AI Assistant',
  'UPDF AI': 'AI Assistant',
  'UPDF Deauthorize': 'Deauthorize UPDF Pro',
  'AI Deauthorize': 'Deauthorize AI Assistant',
  'UPDF AI Authorize': 'Authorize AI Assistant',
  'Approval Management': 'Approval Management',
  'Order Number': 'Order Number',
  'ProductUPDF': 'Product',
  'Number': 'Number',
  'Created at': 'Created at',
  'Payment Method': 'Payment Method',
  'Money': 'Amount',
  'Subscription': 'Subscription',
  'No Subscription': 'No Subscription',
  'UPDF Lifetime': 'Perpetual Plan of UPDF',
  'AI Annual': 'Yearly Plan of AI Assistant',
  'Non payment': 'Unpaid',
  'payment failure': 'Payment Failed',
  'cancel Subscribing': 'Cancel Subscription',
  'Subscribing': 'Subscribing',
  'Orders': 'Order',
  'Create a personal account': 'Create a personal account',
  'CompanyAccount': 'Account',
  'Unauthorized employee': 'Unauthorized employee',
  'Authorized employee': 'Authorized employee',
  'Order': 'Order',
  'Amount of AI plans to be redeemed': 'Amount of AI plans to be redeemed',
  'Amount of UPDF plans to be redeemed': 'Amount of UPDF plans to be redeemed',
  'Pay time': 'Payment time',
  'Quantity': 'Quantity',
  'Payment status': 'Payment status',
  'Active Status': 'Active Status',
  'Insufficient licenses available！Please contact sales.': 'Licenses are insufficient! Please visit the pricing page to purchase or contact sales for help.',
  'Please contact the administrator to obtain authorization so that you can use advanced features.': 'Please contact the administrator to request authorization for access to advanced features.',
  'Administrator Information': 'Administrator Information',
  'Transfer Administrator': 'Transfer Administrator',
  'Are you sure to transfer the administrator?': 'Are you sure to transfer the administrator?',
  'You will be automatically logged out of the Enterprise Management Dashboard after transfering the administrator. The new administrator can directly log in Management Dashboard through his account and password.': 'You will be automatically logged out of the Enterprise Management Dashboard after transferring the administrator. The new administrator can directly log in the Management Dashboard through his or her account and password.',
  'Account binding': 'Link accounts',
  'Please enter your email address and verification code': 'Please enter your email address and verification code',
  'Please input your email': 'Please enter your email',
  'Invalid verification code, please try again': 'Invalid verification code, please try again',
  'Current version': 'Current version',
  'Check for upgrades': 'Check for updates',
  'The current version is already the latest version': 'The current version is already the latest version',
  'Upgrade immediately': 'Upgrade immediately',
  'Send verification code': 'Send verification code',
  'Account or password error': 'Account or password error',
  'Please contact the administrator to reset the password': 'Please contact the administrator to reset the password',
  'Please enter the administrator\'s email': 'Please enter the administrator\'s email',
  'Please enter the 4-digit verification code sent to {account}. <br>Valid for 10 minutes.': 'Please enter the 4-digit verification code sent to {account}. <br>Valid for 10 minutes.',
  'Private Enterprise Account': 'Private Enterprise Account',
  'This software is about to be downloaded to the server, are you sure?': 'This software will be downloaded to the server. Are you sure?',
  'The server will be upgraded, are you sure?': 'The server will be upgraded. Are you sure?',
  'Confirm Upgrade': 'Confirm Upgrade',
  'Checking...': 'Checking...',
  'Server Upgrade': 'Server Upgrade',
  'Software Upgrade': 'Software Upgrade',
  'The upgrade needs to be connected to the Internet, and the latest server configuration can be obtained': 'The upgrade requires an internet connection to obtain the latest server configuration.',
  'Operation failed. Please try again after the server is connected to the Internet': 'Operation failed. Please try again after the server is connected to the Internet.',
  'Operation failed. Please try again after connecting to the local area network': 'Operation failed. Please try again after connecting to the Local Area Network(LAN).',
  'No permission. You are about to be automatically logged out': 'No permission. You will be automatically logged out soon.',
  'Insufficient license is available! Contact sales to buy more.': 'Licenses are insufficient! Please visit the pricing page to purchase or contact sales for help.',
  'Your annual plan has {expireTime} days to expire, please contact sales to purchase perpetual plan.': 'Your Annual Plan has {expireTime} days to expire, please visit the pricing page to buy or contact sales for asisstance.',
  'Password has been reset successfully. Please use the new password to log in.': 'Password has been reset successfully. Please use the new password to log in.',
  'This email is used to reset the administrator password: when the administrator forgets the password, click "forgot password" on the login interface, and a verification code can be sent to this email to reset the password (the verification code needs to be connected to the Internet to receive it). When the administrator is transferred, the email will be changed accordingly, and the new administrator can also bind a new email.': 'This email is used to reset the administrator password: when the administrator forgets the password, click "forgot password" on the login interface, and a verification code can be sent to this email to reset the password (The verification code requires an internet connection to be received.). When the administrator is transferred, the email will be changed accordingly, and the new administrator can also bind a new email.',
  'Your version is already the latest version': 'Your version is already the latest version',
  'The upgrade needs to be connected to the Internet, and the latest software configuration can be obtained': 'The upgrade needs to be connected to the Internet, and the latest software configuration can be obtained',
  'Change binding': 'Change binding',
  'Privatized Enterprise Account': 'Privatized Enterprise Account',
  'Enterprise Management Dashboard': 'Enterprise Management Dashboard',
  'When upgrading, all client software will be suspended, please remind employees to save in time': 'When upgrading, all client software will be suspended, please remind employees to save in time.',
  'Upgrade failed, please try again': 'Upgrade failed, please try again.',
  'http_error_4024': 'The redemption code is for Individual Plan, and cannot be used for Enterprises.',
  'http_error_4408': 'The network connection timed out. An Internet connection is required',
  'This version includes bug fixes and performance improvements': 'This version includes bug fixes and performance improvements',
  'UPDF Annual': 'Yearly Plan of UPDF Pro',
  'Success! Your subscription will be renewed on {data}': 'Successfully! Your subscription will be renewed on {data}',
  'You will miss the membership rights when the subscription expired.': 'You will lose the membership rights once the subscription expired.',
  '⏰ <span>Expire on</span> {data}': '⏰ <span>Expire on</span> {data}',
  'Keep Subscribing': 'Keep Subscribing',
  'Active Subscription': 'Activate the Subscription',
  'UPDF Sign Annually': 'UPDF Sign',
  'UPDF Sign Monthly': 'UPDF Sign',
  'Sign': 'UPDF Sign',
  'UPDF Sign': 'UPDF Sign',
  'Your account now has full access to all UPDF Sign features.': 'Your account now has full access to all UPDF Sign features.',
  'Full access to all UPDF Sign features and UPDF Cloud benefits.': 'Full access to all UPDF Sign and UPDF Cloud features.',
  'UPDF Sign Authorize': 'Authorize UPDF Sign',
  'Buy Sign Licenses': 'Buy UPDF Sign',
  'Amount of Sign plans to be redeemed': 'Number of UPDF Sign licenses available for redemption.',
  'Sign Authorize': 'Authorize UPDF Sign',
  'Sign Deauthorize': 'Deauthorize UPDF Sign',
  'Keep UPDF Sign': 'Keep UPDF Sign',
  'Legally binding digital signature (certified by AATL).++Automatically notify recipients when signature is sent.++Multiple file signing and batch sending.++Save and manage digital signatures for long-term use.++Provides audit trail and certification.': 'Legally binding digital signature (certified by AATL).++Automatically notify recipients when signature is sent.++Multiple file signing and batch sending.++Save and manage digital signatures for long-term use.++Provides audit trail and certification.',
  '{number} signature requests per year.': '{number} signature requests per year.',
  '{number} signature requests per month.': '{number} signature requests per month.',
  'Legally binding digital signature (certified by AATL).': 'Legally binding digital signature (certified by AATL).',
  'Automatically notify recipients when signature is sent.': 'Automatically notify recipients when signature is sent.',
  'Multiple file signing and batch sending.': 'Multiple file signing and batch sending.',
  'Save and manage digital signatures for long-term use.': 'Save and manage digital signatures for long-term use.',
  'Provides audit trail and certification.': 'Provides audit trail and certification.',
  '20GB cloud storage.': '20GB cloud storage.',
  '24*7 customer service support.': '24*7 customer service support.',
  'Register & log in UPDF account You can convert <span>2 files per day</span> for FREE': 'Register and log in UPDF account. You can convert <span>2 files per day</span> for free.',
  'The annual membership signature quota is unlimited and cannot be modified after authorization to employees. Confirm the authorization?': 'The Yearly Plan of UPDF Sign includes unlimited signature requests. Once you authorize an employee, you cannot transfer the authorization to another employee. Do you confirm the authorization?',
  'Authorized employees do not support cancellation. If you need to change, you can contact sales to modify it once.': 'Authorized employees do not support cancellation. If you need to change, you can contact sales to modify it once.',
  'Usage of amount': 'Usage Overview:',
  'Total signature amount:': 'Total Signing Requests:',
  'Expiration date:': 'Expiration Date：',
  'Remaining amount:': 'Remaining Signing Requests:',
  'Usage of Amount Detail': 'Detailed Usage Overview:',
  'Amount Consumed': 'Signing Requests Used:',
  'Last Consumption Time': 'Last Usage Time:',
  'According to the billing process of relevant institutions, we will complete the billing for users every Wednesday': 'According to the billing process of relevant institutions, we will complete the billing for users every Wednesday',
  'If you need to create a personal account for use, click here': 'If you need to create a personal account for use, click here',
  'Cancelled': 'Cancelled',
  'http_error_403': 'No Permission',
  'http_error_408': 'Request timeout. Please try again',
  'http_error_500': 'System or parameters error. Please try again',
  'http_error_1401': 'Verification failed. Please check your input data',
  'http_error_2001': 'Account already exists',
  'http_error_2002': 'Invalid verification code. Please try again',
  'http_error_2003': 'Too many verification codes sent. Please try again later',
  'http_error_2004': 'Too many login attempts from your IP. Please try again later',
  'http_error_2005': 'Over 5 failed password attempts',
  'http_error_2006': 'Your session is expired. Please relogin',
  'http_error_2007': 'You\'re logging in and out too frequently',
  'http_error_2008': 'Session exception, please log in again',
  'http_error_2009': 'You\'re not logged in. Please log in',
  'http_error_2012': 'The account has been linked, please unlink or delete the account and try again',
  'http_error_2403': 'Account or password incorrect',
  'http_error_2404': 'Account does not exist',
  'http_error_2411': 'Email sending failed! Please try again or check your email address.',
  'http_error_4004': 'Not support renewal',
  'http_error_4005': 'License Used.',
  'http_error_4006': 'The license was scrapped',
  'http_error_4007': 'The license was offline',
  'http_error_4008': 'The license was deleted',
  'http_error_4009': 'License Expired',
  'http_error_4015': 'You cannot use this coupon on this product',
  'http_error_4016': 'Coupon usage limit has been reached.',
  'http_error_4019': 'Goods data not found.',
  'http_error_4020': 'Coupon doesn’t exist',
  'http_error_4021': 'Order data not found.',
  'http_error_4022': 'Plan data not found.',
  'http_error_4026': 'The redeemed code has expired.',
  'http_error_4027': 'Coupon doesn’t exist',
  'http_error_4028': 'You are already a perpetual member, no need to redeem.',
  'http_error_4014': 'Account Not Match',
  'http_error_4401': 'Get server token error',
  'http_error_4404': 'Data not found',
  'http_error_4502': 'Time out,please try again',
  'http_error_6004': 'can\'t delete your self',
  'http_error_6001': 'Can not authorize yourself',
  'http_error_6002': 'Can not cancel the authorization of yourself',
  'http_error_6003': 'Licenses are insufficient',
  'http_error_6005': 'Invite code expired',
  'http_error_6506': 'Exported data is empty',
  'http_error_6507': 'Import not complete',
  'http_error_6508': 'Imported file is empty',
  'http_error_6509': 'Not valid Excel format',
  'http_error_6012': 'Email already exists',
  'http_error_6013': 'Phone number already exists',
  'http_error_6006': 'The current enterprise has been disabled',
  'http_error_2204': 'Your subscription plan is active, please cancel your subscription before deleting account.',
  'UPDF Account Center': 'UPDF Account Center',
  'Profile': 'Profile',
  'Products and Plans': 'Products and Plans',
  'Payment and Order': 'Payment and Order',
  'Account Settings': 'Account Settings',
  'Account Types': 'Account Types',
  'Save Changes': 'Save Changes',
  'Newsletter Subscription Preferences': 'Newsletter Subscription Preferences',
  'Subscribe to our newsletter about news, offers and tips.': 'Subscribe to our newsletter about news, offers and tips.',
  'Redeem License': 'Redeem License',
  'You can manage the credit card for your subscription order here. Credit cards are stored by third-party payment institutions, and we at UPDF do not store any credit card information. If you need to unbind, please cancel your subscription in “Product and Plans” first.': 'You can manage the credit card for your subscription order here. Credit cards are stored by third-party payment institutions, and we at UPDF do not store any credit card information. If you need to unbind, please cancel your subscription in “Product and Plans” first.',
  'Order information only included orders purchased through rhe website. Apple Pay and Google Pay orders will not be displayed here.': 'The order information only includes orders purchased through the website. Orders made with Apple Pay and Google Pay will not be displayed here.',
  'Card Details': 'Card Details',
  'Device Name': 'Device Name',
  'Location': 'Location',
  'Manage': 'Manage',
  'Linked Account': 'Linked Account',
  'Status': 'Status',
  'Actions': 'Actions',
  'No data': 'No data',
  'Log in with WeChat Scan': 'Log in with WeChat',
  'Log in with Account/Email/Phone Number': 'Log in with Account/Email/Phone Number',
  'Registration is successful! Please fill in the following information': 'Registration is successful! Please fill in the following information',
  'Get Started': 'Get Started',
  'Subscribe to our newsletter, Offers and Tips.': 'Subscribe to our newsletter about news, offers and tips.',
  'Please verify you are human': 'Please verify you are human',
  'Let us get to know you better': 'Let us know you better',
  'How do you plan to use UPDF?': 'How do you plan to use UPDF?',
  'For personal use': 'For personal use',
  'For work': 'For work',
  'For my study or education work': 'For my study or education work',
  'How did you hear about us?': 'How did you hear about us?',
  'Search (Google, Bing, etc.)': 'Search (Google, Bing, etc.)',
  'Internet(newsletter, publication, blog etc.)': 'Internet(newsletter, publication, blog etc.)',
  'Internet ads': 'Internet ads',
  'Youtube': 'Youtube',
  'Tiktok': 'TikTok',
  'Social media(Linkedin, Facebook, X, instagram etc.)': 'Social media(Linkedin, Facebook, X, instagram etc.)',
  'From a friend or colleague': 'From a friend or colleague',
  'Others(please specify)': 'Others(please specify)',
  'Please specify': 'Please specify',
  'What features do you plan to use with UPDF?': 'What features do you plan to use?',
  'AI': 'AI',
  'Edit PDF': 'Edit PDF',
  'Annotate PDF': 'Annotate PDF',
  'Convert PDF': 'Convert PDF',
  'OCR': 'OCR',
  'Create, fill and sign PDFs': 'Create, fill and sign PDFs',
  'Organize PDF pages': 'Organize PDF pages',
  'Redact and protect PDFs': 'Redact and protect PDFs',
  'I don\'t know yet': 'I don\'t know yet',
  'What’s your age group?': 'What’s your age group?',
  'Under 18': 'Under 18',
  '18-24': '18-24',
  '25-34': '25-34',
  '35-44': '35-44',
  '45-54': '45-54',
  '55-64': '55-64',
  '65 and over': '65 and over',
  'I prefer not to say': 'I prefer not to say',
  'What kind of work do you do?': 'What kind of work do you do?',
  'Select your role or job title': 'Select your role or job title',
  '本科在读': '本科在读',
  '硕士在读': '硕士在读',
  '博士在读': '博士在读',
  '教师': '教师',
  'Education (students or education Staff)': 'Education (students or education Staff)',
  'Healthcare': 'Healthcare',
  'IT': 'IT',
  'Finance': 'Finance',
  'Legal': 'Legal',
  'Creative industries': 'Creative industries',
  'Engineering': 'Engineering',
  'Goverment and public service': 'Goverment and public service',
  'Non-profit and NGOs': 'Non-profit and NGOs',
  'Media and entertainment': 'Media and entertainment',
  'Marketing and advertising': 'Marketing and advertising',
  'Energy and utilities': 'Energy and utilities',
  'Manufacturing_1': 'Manufacturing',
  'Real estate': 'Real estate',
  'Human resource': 'Human resource',
  'Telecommunication': 'Telecommunication',
  'Consulting': 'Consulting',
  'Building and construction': 'Building and construction',
  'Retired': 'Retired',
  'Others': 'Others',
  'Tell us a bit more': 'Tell us a bit more',
  'Next': 'Next',
  'Skip All': 'Skip All',
  'Finish': 'Finish',
  'Registration is successful!': 'Registration is successful!',
  'Change Payment Method': 'Change Payment Method',
  'http_error_1400': 'Human verification failed.',
  'http_error_2400': 'Email verification failed.',
  'http_error_6011': 'Account already exists',
  'Feedback': 'Feedback',
  'Very Dissatisfied': 'Very Dissatisfied',
  'Dissatisfied': 'Dissatisfied',
  'Neutral': 'Neutral',
  'Satisfied': 'Satisfied',
  'Very Satisfied': 'Very Satisfied',
  'Attachment': 'Attachment',
  'Is there anything we can help you with?': 'Is there anything we can help you with?',
  'Your email': 'Your email',
  'Hello, we have received your feedback and will respond to you as soon as possible. Please be patient, and thank you for your understanding.': 'Hello, we have received your feedback and will respond to you as soon as possible. Thanks for your patience and understanding.',
  'Submission Failed': 'Submission Failed',
  'Please correctly fill in your email address.': 'Please correctly fill in your email address.',
  'Invalid email address, please re-enter.': 'Invalid email address, please re-enter.',
  'Please provide detailed feedback content.': 'Please provide detailed feedback content.',
  'Unbind Card': 'Unlink Card',
  'Are you sure you want to unlink this credit card?': 'Are you sure you want to unlink this credit card?',
  'Unbind': 'Unlink',
  'Use email verification': 'Use email verification',
  'Use phone verification': 'Use phone number verification',
  'Permanently delete your personal information and all data, this operation can’t be reconvered.': 'Permanent deletion of your personal information and data cannot be recovered.',
  'Please select one of the currently linked accounts to receive the verification code to proceed with your account deactivation.': 'Please select one of the linked accounts for verification',
  'Other verification methods': 'Other verification methods',
  'All devices that have permission to log in to this account will be displayed here. If you do not want a device to continue logging into the account, you can remove the device in time and <a href="#" class="change-pass">change the password</a>.': 'All devices that have permission to log in to this account will be displayed here. If you do not want a device to continue logging into the account, you can remove the device in time and <a href="#" class="change-pass">change the password</a>.',
  'All devices that have permission to log in to this account will be displayed here. If you do not want a device to continue logging into the account, you can remove the device in time.': 'All devices that have permission to log in to this account will be displayed here. If you do not want a device to continue logging into the account, you can remove the device in time.',
  '<span>{inviteNickName}</span> invites you to join <span>{companyName}</span> to share UPDF membership benefits.': '<span>{inviteNickName}</span> invites you to join <span>{companyName}</span> to share UPDF membership benefits.',
  'You’ve been invited': 'You’ve been invited',
  'Free Trial': 'Free Trial',
  'Accept now to access exclusive UPDF membership benefits.': 'Accept now to access exclusive UPDF membership benefits.',
  'Accept Invitation': 'Accept Invitation',
  'Welcome aboard! You’re all set.': 'Welcome aboard! You’re all set.',
  'Download now to share membership benefits.': 'Download and log in to unlock all the features of UPDF.',
  'Start Using UPDF': 'Start to use UPDF',
  'Account Details': 'Account Details',
  'After unsubscribing, you will no longer receive our email notifications, news, offers, and tips.': 'After unsubscribing, you will no longer receive our email about news, offers, and tips.',
  'You can manage the credit card for your subscription order here. Credit cards are stored by third-party payment institutions, and we at UPDF do not store any credit card information. If you need to unbind, please cancel your subscription in “Product & Plans” first.': 'You can manage the credit card for your subscription order here. Credit cards are stored by third-party payment institutions, and UPDF will not store any credit card information. If you need to unlink your cards, please cancel your subscription in “Product & Plans” first.',
  'Order information only included orders purchased through rhe website. Apple Pay and Google Google Pay orders will not be displayed here.': 'Order information only lists orders made through UPDF\'s official website. Orders from third-party platforms such as Apple Store or Goolge Play Store or other deals websites will not be displayed here.',
  'Work': 'Work',
  'Age': 'Age',
  'Please enter the code sent to<br><span>{account}</span>.': 'Please enter the code sent to<span>{account}</span>',
  'The code is valid for 10 minutes.': 'The code is valid for 10 minutes.',
  'SSO Log in': 'SSO Log in',
  'Upgrade AI Assistant to unlock more AI features': 'Upgrade AI Assistant to unlock more AI features',
  'Profile Picture': 'Profile Picture',
  'Account Deletion Confirmation': 'Account Deletion Confirmation',
  'Email/phone number': 'Email/Phone number',
  'Account/email/phone number': 'Account/Email/Phone Number',
  'Account/email': 'Account/Email',
  'Get our desktop/mobile app': 'Get UPDF Desktop/Mobile App',
  'Plan Types': 'Plan Types',
  'Details': 'Details',
  'Redeemable {isProduct} Membership Duration:': 'Redeemable {isProduct} Membership Duration:',
  'Redeemable Membership Duration:': 'Redeemable Membership Duration:',
  'Tax Code': 'Tax Code',
  'http_error_4031': 'You\'ve already had a plan, and there is no need to buy again',
  'Send code_2': 'Send Code',
  'View Plans': 'View Plans',
  'Add Credit Card': 'Add Credit Card',
  'Account Information': 'Account Information',
  'There are no orders. Would you like to upgrade your plan? <br>Please visit the pricing page to make a purchase.': 'There are no orders. Would you like to upgrade your plan? <br>Please visit the pricing page to make a purchase.',
  'Human-machine verification failed, <span>click to retry</span>': 'Human-machine verification failed, <span>click to retry</span>',
  'Subscribed Successfully': 'Subscribed Successfully',
  'Unsubscribe': 'Unsubscribe',
  'Upgrade to UPDF Sign Plan to unlock more Sign features': 'Upgrade to UPDF Sign Plan to unlock more Sign features',
  'Subscribe': 'Subscribe',
  'Please scan the QR code using WeChat': 'Please scan the QR code using WeChat',
  'Enter your redemption code': 'Enter your redemption code',
  'Credit Card': 'Credit Card',
}